import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// Angular 2 Input Mask
import { TextMaskModule } from 'angular2-text-mask';

// Timepicker
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

// Datepicker
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

//loading buttons
import { LaddaModule } from 'angular2-ladda';

//panel accordion
import { CollapseModule } from 'ngx-bootstrap/collapse';

// Modal Component
import { ModalModule } from 'ngx-bootstrap/modal';
import { SelectModule } from 'ng-select';
import { GtPlusModule } from  './views/gt-plus/gt-plus.module';







const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
  
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { LoginComponent } from './views/login/login.component';
import { ChangePasswordComponent } from './views/change-password/change-password.component';
import { ResetPasswordComponent } from './views/reset-password/reset-password.component';

import {MyprofileModule} from './views/student-profile/myprofile/myprofile.module';
import { DashboardModule } from './views/dashboard/dashboard.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import {TestpageModule } from './views/student-profile/test-page/test-page.module';
import { AdminComponent } from './views/admin/admin.component';
import { UserManagementComponent } from './views/user-management/user-management.component';
import { TestManagementComponent } from './views/test-management/test-management.component';
import { WalletTopupComponent } from './containers/wallet-topup/wallet-topup.component';

import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UpdateBalanceService } from './Services/update-balance.service';
import { LogOfTestBalanceComponent } from './views/log-of-test-balance/log-of-test-balance.component';
import { LogOfWalletComponent } from './views/log-of-wallet/log-of-wallet.component';
//import {DashboardComponent} from './views/dashboard/dashboard.component' 

import {TrailtestModule} from './views/trail-test/trail-test.module';
import { TokenInterceptor } from './Services/token.interceptor';
import { AuthService } from './Services/auth.service';
import { TrailTestModalComponent } from './views/trail-test-modal/trail-test-modal.component';
import { TrailTestStartPopupComponent } from './views/trail-test-modal/trail-test-start-popup/trail-test-start-popup.component';
import { DownloadTestModalComponent } from './views/download-test-modal/download-test-modal.component';
import { TermsConditionComponent } from './views/terms-condition/terms-condition.component';
import { PrivacyPolicyComponent } from './views/privacy-policy/privacy-policy.component';
import { RefundPolicyComponent } from './views/refund-policy/refund-policy.component';
import { ShippingPolicyComponent } from './views/shipping-policy/shipping-policy.component';
import { AboutComponent } from './views/about/about.component';
import { ContactComponent } from './views/contact/contact.component';
import { ImageSelectionQuestionComponent } from './views/image-selection-question/image-selection-question.component';
import { ImageSelectionPopupComponent } from './views/image-selection-popup/image-selection-popup.component';
import { MoodLightTestingComponent } from './views/mood-light-testing/mood-light-testing.component';
import { MindTendencyTestComponent } from './views/mind-tendency-test/mind-tendency-test.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { CarouselModule } from 'ngx-owl-carousel-o';



@NgModule({
  imports: [
    BrowserModule,
    GtPlusModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    SelectModule,
    TextMaskModule,
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    LaddaModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    MyprofileModule,
    TrailtestModule,
    DashboardModule,
    HttpClientModule,
    FormsModule,
    TestpageModule,
     NgbModule,
     ProgressbarModule,
     CarouselModule
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LoginComponent,
    ChangePasswordComponent,
    ResetPasswordComponent,
    AdminComponent,
    UserManagementComponent,
    TestManagementComponent,
    WalletTopupComponent,
    LogOfTestBalanceComponent,
    LogOfWalletComponent,
    TrailTestModalComponent,
    TrailTestStartPopupComponent,
    DownloadTestModalComponent,
    TermsConditionComponent,
    PrivacyPolicyComponent,
    RefundPolicyComponent,
    ShippingPolicyComponent,
    AboutComponent,
    ContactComponent,
    ImageSelectionQuestionComponent,
    ImageSelectionPopupComponent,
    MoodLightTestingComponent,
    MindTendencyTestComponent,
    AutoFocusDirective,
   // DashboardComponent
   
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
    
    
  },
  AuthService,
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  NgbActiveModal,UpdateBalanceService,
],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
